module.exports = __webpack_public_path__ + "./images/ef8e6d1d48bfab454b7ad0781ffec586.webp";